import { Check, X } from "lucide-react";
import { PASSWORD_RULE_MESSAGE, passwordCheckBreakdown } from "../lib/passwordPolicy";

/**
 * Live visual indicator of the 4 password rules.
 * Shows the overall message + each rule with a green check or a red cross.
 *
 * Usage:
 *   <PasswordRules password={pwd} />
 */
export default function PasswordRules({ password = "", compact = false }) {
  const c = passwordCheckBreakdown(password);
  const rules = [
    { ok: c.length, label: "Au moins 8 caractères" },
    { ok: c.letter, label: "Au moins 1 lettre" },
    { ok: c.digit, label: "Au moins 1 chiffre" },
    { ok: c.special, label: "Au moins 1 caractère spécial" },
  ];

  return (
    <div className="mt-2" data-testid="password-rules">
      <p className="text-xs text-subtle leading-snug">{PASSWORD_RULE_MESSAGE}</p>
      <ul className={`mt-2 grid ${compact ? "grid-cols-2 gap-x-3 gap-y-1" : "grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1"}`}>
        {rules.map((r) => (
          <li
            key={r.label}
            className={`flex items-center gap-1.5 text-[11px] ${r.ok ? "text-[#0A7F2E]" : "text-subtle"}`}
            data-testid={`pwd-rule-${r.label}`}
          >
            {r.ok ? <Check size={12} /> : <X size={12} />}
            <span>{r.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
